import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { InicioService } from 'src/app/@pages/dashboard/servicios/inicio.service';
import { clienteService, productoModel, productoService, ventaService } from '../../shared/models/checkout';
import { CheckoutService } from '../../shared/servicios/checkout.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  referencia;
  responseRef;
  productos;

  productoForm;
  ciudadSelected;
  Ciudades;
  filteredOptions: Observable<any[]>;

  valorT = 0;

  objetoProducto;
  objetoVenta;
  objetoCliente;

  imgenLogo;
  timeNow;

  idPedidoFinal;

  mensajeSpinner = 'Cargando';

  cuadForm: boolean = false;
  cuadPreV: boolean = false;
  cuadChar: boolean = false;
  cuadFin: boolean = false;
  cuandErr: boolean = false;

  msgError = 'Intente nuevamente, si el error persiste contacte a soporte';

  constructor(private inicioService: InicioService, private formBuilder: FormBuilder, private route: ActivatedRoute, private checkoutService: CheckoutService) {
    // referencia
    this.referencia = this.route.snapshot.paramMap.get('referencia');
    this.iniciarForm();
    // console.log(this.referencia);
  }

  ngOnInit(): void {
    this.getDetalleUrl();

    let now = new Date(Date.now())
    this.timeNow = now.getUTCFullYear().toString() + ((now.getUTCMonth() + 1) > 9 ? (now.getUTCMonth() + 1).toString() : '0' + (now.getUTCMonth() + 1).toString()) + ((now.getUTCDate()) > 9 ? now.getUTCDate().toString() : '0' + now.getUTCDate().toString());
    // console.log(this.timeNow)
  }

  getDetalleUrl(): void {
    this.checkoutService.getUrlDetalle(this.referencia).subscribe((data) => {
      this.responseRef = data[0];
      if (this.responseRef) {
        // console.log('Ref', this.responseRef)
        this.imgenLogo = this.responseRef.id_tienda;
        this.getProductos();
      }
    }, (err) => {
      this.cuadForm = false;
      this.cuandErr = true;
    });
  }

  getProductos(): void {
    this.checkoutService.getProductoCheckout(this.responseRef.id_producto, this.responseRef.id_tienda).subscribe((data) => {
      this.productos = data[0];
      if (data[0].response === ('El producto se encuentra inactivo')) {
        this.cuadForm = false;
        this.cuandErr = true;
        this.msgError = 'El producto se encuentra inactivo';
      } else if (data[0].response === ('No hay unidades disponibles')) {
        this.cuadForm = false;
        this.cuandErr = true;
        this.msgError = 'No hay unidades disponibles';
      } else {
        this.valorT = this.productos.precio_venta;
        this.getCiudades(this.productos.id_origen_venta);
      }
    }, (err) => {
      this.cuadForm = false;
      this.cuandErr = true;
    })
  }

  getCiudades(id): void {
    this.checkoutService.getCiudadesCheckout(id, this.responseRef.pais_tienda).subscribe((data) => {
      let city = data;
      this.Ciudades = city.sort(function (a, b) {
        if (a.ciudad_full > b.ciudad_full) {
          return 1;
        }
        if (a.ciudad_full < b.ciudad_full) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

      // console.log(this.Ciudades);

      this.addListeners();

    }, (err) => {
      this.cuadForm = false;
      this.cuandErr = true;
    })
  }

  //TRAE VALORES DE LA CIUDAD
  addListeners(): void {
    this.filteredOptions = this.productoForm.get('ciudadCtrl').valueChanges.pipe(
      startWith(''),
      map((value) => {
        return this.ciudadFilter(value);
      })
    );
    // this.filteredOptions = this.productoForm.controls.ciudadCtrl.valueChanges.pipe(
    //   startWith(''),
    //   map((value) => {
    //     // value ? this._filterStates(value) : this.Ciudades.slice()
    //     // console.log(value)
    //     return this.ciudadFilter(value);
    //   })
    // );
  }

  //FILTRO DE CIUDAD
  private ciudadFilter(ciudad: any) {
    // console.log(ciudad)
    ciudad = ciudad === null ? '' : ciudad;
    const filterValue = ciudad.toLowerCase();
    const filtered = this.Ciudades.filter((option) =>
      option.ciudad_full.toLowerCase().includes(filterValue)
    );
    // const filtered = this.Ciudades.filter((option) =>
    //   option.ciudad.toLowerCase().indexOf(filterValue) === 0
    // );
    if (filtered.length > 0) {
      let found = this.Ciudades.find(element =>
        ciudad === element.ciudad_full
      );
      if (found === undefined) {
        this.productoForm.get('ciudadCtrl').setErrors({ required: true });
      } else {
        this.productoForm.get('ciudadCtrl').setErrors(false);
      }
      // console.log(found)
      return filtered;
    }
    else {
      this.productoForm.get('ciudadCtrl').setErrors({ required: true });
      return [];
    }
  }

  iniciarForm(): void {
    this.productoForm = this.formBuilder.group({
      nombreCtrl: ['', [Validators.required, Validators.maxLength(60)]],
      telefonoCtrl: ['', [Validators.required, Validators.pattern("[0-9]{10}")]],
      emailCtrl: ['', [Validators.required, Validators.email]],
      ciudadCtrl: ['', [Validators.required]],
      direccionCtrl: ['', [Validators.required]],
      cantidadCtrl: [1, [Validators.required, Validators.min(1)]],
      metodoCtrl: ['', [Validators.required]]
    });
    this.cuadForm = true;
    this.onChangesCantidad();
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOption(ciudad: any, e): void {
    if (e.isUserInput) {
      this.ciudadSelected = ciudad;
      // console.log(this.ciudadSelected)
    }
  }

  onChangesCantidad() {
    this.productoForm.get('cantidadCtrl').valueChanges.subscribe((val) => {
      this.valorT = this.productos.precio_venta * val;
      // console.log("cantidad" + val);
    })
  }

  getControl(control: string): AbstractControl {
    /* tslint:disable */
    return this.productoForm.get(control);
    /* tslint:enable */
  }

  volverForm(): void {
    this.cuadForm = true;
    this.cuadPreV = false;
  }

  preVenta(): void {
    if (this.productoForm.valid) {
      this.cuadForm = false;
      this.cuadPreV = true;

      const valueFormVenta: productoModel = { ...this.productoForm.value };

      this.objetoProducto = this.setObjectoProducto(valueFormVenta)

      // console.log(this.objetoProducto)
    }
  }

  venta(): void {
    this.cuadForm = false;
    // this.cuadPreV = false;
    this.mensajeSpinner = 'Tu pedido esta siendo procesado';
    this.cuadChar = true;

    const valueFormVenta: productoModel = { ...this.productoForm.value };

    this.objetoCliente = this.setCrearCliente(valueFormVenta)

    // console.log(this.objetoCliente)

    // GENERANDO CLIENTE
    this.checkoutService.guardarCliente(this.objetoCliente, this.responseRef.pais_tienda).subscribe((data) => {

      console.log(data)
      setTimeout(() => {

        if (data[0].respuesta === 'Success') {
          this.mensajeSpinner = 'Tu pedido esta siendo procesado...';

          this.objetoVenta = this.setObjetoVenta(valueFormVenta)

          // GENERANDO VENTA
          this.checkoutService.guardarVenta(this.objetoVenta).subscribe((data2) => {
            console.log(data2)
            if (data2[0].respuesta.includes('exito')) {
              let dato = data2[0].respuesta;
              this.idPedidoFinal = dato.split(':')[1];

              if (valueFormVenta.metodoCtrl !== 'Contraentrega') {

                this.mensajeSpinner = 'Generando link de pago';

                let linkObject = this.setObjectLink(valueFormVenta, this.idPedidoFinal)

                setTimeout(() => {

                  // GENERANDO LINK DE PAGO

                  this.checkoutService.linkCheckout(linkObject).subscribe((data) => {

                    this.mensajeSpinner = 'Redirigiendo a pagina de pago...';

                    if (data[0].respuesta === 'Acceso denegado') {
                      this.cuadChar = false;
                      this.cuandErr = true;
                    } else {
                      setTimeout(() => {
                        location.replace(data[0].respuesta);
                      }, 2000);
                    }
                  }, (err) => {
                    this.cuadChar = false;
                    this.cuandErr = true;
                  })
                }, 2000);

              } else {
                this.cuadChar = false;
                this.cuadFin = true;
              }
            } else {
              this.cuadChar = false;
              this.cuandErr = true;
            }

          }, (err) => {
            console.log(err)
            this.cuadChar = false;
            this.cuandErr = true;
          })
        } else {
          this.cuadChar = false;
          this.cuandErr = true;
        }
      }, 2000);

    }, (err) => {
      this.cuadChar = false;
      this.cuandErr = true;
    })
  }

  // CREA OBJETOS

  setObjectoProducto(valueForm: productoModel): productoService {
    return {
      nombre: valueForm.nombreCtrl,
      telefono: valueForm.telefonoCtrl,
      correo: valueForm.emailCtrl,
      id_ubicacion: valueForm.ciudadCtrl,
      direccion: valueForm.direccionCtrl,
      cantidad: valueForm.cantidadCtrl,
      valor_recaudo: this.valorT,
      forma_pago: valueForm.metodoCtrl
    }
  }

  setCrearCliente(valueForm: productoModel): clienteService {
    return {
      telefono: valueForm.telefonoCtrl,
      nombre: valueForm.nombreCtrl,
      cedula: '0',
      id_ubicacion: this.ciudadSelected.id_ciudad,
      direccion: valueForm.direccionCtrl,
      barrio: '',
      correo: valueForm.emailCtrl,
      facebook: '',
      novedad: '',
      genero: '',
      calle_carrera: '',
      num1: '',
      tipo1: '-Sel',
      sur1: '-Sel',
      num2: '',
      tipo2: '-Sel',
      sur2: '-Sel',
      num3: '',
      bloque_torre: '-Sel',
      num_torre: '',
      apto_casa: '',
      num_apto: '',
      nombre_edificio: '',
      detalles: valueForm.direccionCtrl
    }
  }

  setObjetoVenta(valueForm: productoModel): ventaService {
    return {
      usuario_login: this.responseRef.usuario,
      id_tienda: this.responseRef.id_tienda,
      alto: this.productos.alto,
      ancho: this.productos.ancho,
      cantidad_cajas: '1',
      detalle_venta: JSON.stringify([{
        id_producto: this.productos.id_producto,
        cantidad: valueForm.cantidadCtrl,
        detalle: ''
      }]),
      es_contraentega: (valueForm.metodoCtrl === 'Contraentrega' ? 'SI' : 'NO'),
      forma_pago: valueForm.metodoCtrl,
      fecha_programada: this.timeNow,
      guia_anterior: '',
      largo: this.productos.profundo,
      origen_venta: this.productos.id_origen_venta,
      peso_volumen: this.calculoPesoVolumen(this.productos.alto, this.productos.ancho, this.productos.profundo),
      registra_novedad: 'NO',
      novedad: '',
      telefono: valueForm.telefonoCtrl,
      valor_declarado: '10000',
      valor_recaudo: this.valorT.toString(),
      valor_recaudo_calculado_sistema: this.valorT.toString(),
      verificador_externo: this.responseRef.validador
    }
  }

  setObjectLink(valueForm: productoModel, id: any): any {
    let sBrowser, sUsrAg = navigator.userAgent;;

    if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome";
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari";
    } else if (sUsrAg.indexOf("Opera") > -1) {
      sBrowser = "Opera";
    } else if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
    } else if (sUsrAg.indexOf("MSIE") > -1) {
      sBrowser = "Microsoft Internet Explorer";
    }

    return {
      key: 'NA',
      id_tienda_login: this.responseRef.id_tienda,
      nombre_cliente: valueForm.nombreCtrl,
      email: valueForm.emailCtrl,
      cedula: '0',
      telefono: valueForm.telefonoCtrl,
      id_registro: id.trim(),
      referencia: id.trim(),
      detalle_venta: this.productos.nombre_producto,
      total: this.valorT.toString(),
      ip: '0.0.0.0',
      user_agent: sBrowser,
      tipo_link: 'Guia',
      verificador_externo: this.responseRef.validador
    }
  }

  calculoPesoVolumen(alto, ancho, profundo): string {
    const resultado = ((alto / (100) * (ancho / 100) * (profundo / 100)) * 222);
    return resultado.toString();
  }

  changeCoin(): String {
    const idCountry = this.responseRef?.pais_tienda;
    if (idCountry === '57') {
      return 'COP';
    } else if (idCountry === '593' || idCountry === '1') {
      return 'USD';
    } else if (idCountry === '11') {
      return 'CAD';
    }
  }

  changeValueCoin(valor): void {
    const idCountry = this.responseRef?.pais_tienda;
    // VALORES MAYORES
    if (valor > 0) {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor.toString();
        let valorFinal = valor2;
        let i;
        for (i = 0; i <= valorFinal.length; i++) {
          if (i === 4 || i === 8 || i === 12 || i === 16) {
            let num = i - 1;
            valorFinal = valorFinal.slice(0, valorFinal.length - num) + ',' + valorFinal.slice(-num);
          }
        }
        return valorFinal;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11') {
        const valor2 = valor.toString();
        let valor3 = valor2.replace(',', '.');
        let valorFinal = valor3.split('.');
        if (valorFinal.length > 1) {
          let vF1 = valorFinal[0];
          let decimalVF1 = valorFinal[1].slice(0, 2);
          for (let i = 0; i <= vF1.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF1 = vF1.slice(0, vF1.length - num) + ',' + vF1.slice(-num);
            }
          }
          vF1 = vF1 + '.' + decimalVF1;
          return vF1;
        } else {
          let vF2 = valorFinal[0];
          for (let i = 0; i <= vF2.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF2 = vF2.slice(0, vF2.length - num) + ',' + vF2.slice(-num);
            }
          }
          return vF2;
        }
      }
    } // VALORES MENORES 
    else if (valor < 0) {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor.toString();
        let valorFinal = valor2.replace('-', '');
        let i;
        for (i = 0; i <= valorFinal.length; i++) {
          if (i === 4 || i === 8 || i === 12 || i === 16) {
            let num = i - 1;
            valorFinal = valorFinal.slice(0, valorFinal.length - num) + ',' + valorFinal.slice(-num);
          }
        }
        valorFinal = '-' + valorFinal;
        return valorFinal;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11') {
        const valor2 = valor.toString();
        let valor3 = valor2.replace(',', '.');
        let valor4 = valor3.replace('-', '');
        let valorFinal = valor4.split('.');
        if (valorFinal.length > 1) {
          let vF1 = valorFinal[0];
          let decimalVF1 = valorFinal[1].slice(0, 2);
          for (let i = 0; i <= vF1.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF1 = vF1.slice(0, vF1.length - num) + ',' + vF1.slice(-num);
            }
          }
          vF1 = '-' + vF1 + '.' + decimalVF1;
          return vF1;
        } else {
          let vF2 = valorFinal[0];
          for (let i = 0; i <= vF2.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF2 = vF2.slice(0, vF2.length - num) + ',' + vF2.slice(-num);
            }
          }
          vF2 = '-' + vF2;
          return vF2;
        }
      }
    } else {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor;
        return valor2;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11') {
        const valor2 = valor;
        return valor2;
      }
    }
  }

}
